export const authScreens = {
  accesoDirecto: {
    loading: "Signing in to your account…",
  },
  confirmar: {
    verifying: "Verifying account…",
    verifiedSuccess: "Account verified successfully",
    tokenInvalid: "The token doesn't exist or has already expired",
    backHome: "Back to Home",
  },
  recovery: {
    title: "Reset password",
    successTitle: "Success!",
    successDesc:
      "Your password was changed successfully. Redirecting you to the start…",
    infoTitle: "Create a new password",
    infoDesc:
      "Changing it will sign out all active sessions on your other devices.",
    newPasswordLabel: "New password",
    newPasswordPlaceholder: "Enter your new password",
    togglePasswordAria: "Show/hide password",
    confirmPasswordLabel: "Repeat password",
    confirmPasswordPlaceholder: "Repeat your new password",
    passwordsMismatch: "Passwords don't match.",
    submit: "Change password",
    submitting: "Processing…",
    backToStart: "Back to start",
    footerWeb: "Website",
    toastInvalidLink: "The recovery link is invalid or has expired.",
    errorGeneric: "We couldn't change the password.",
  },
};
